import {
  GET_AUDIENCE_COUNT_START,
  GET_AUDIENCE_COUNT_SUCCESS,
  GET_AUDIENCE_COUNT_ERROR,
} from 'constants/action-types/organizations/audienceCount';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_AUDIENCE_COUNT_START:
      return {
        ...state,
        audienceCount: {
          ...state.audienceCount,
          loading: true,
          error: null,
        },
      };
    case GET_AUDIENCE_COUNT_ERROR:
      return {
        ...state,
        audienceCount: {
          ...state.audienceCount,
          error: payload,
          loading: false,
        },
      };
    case GET_AUDIENCE_COUNT_SUCCESS:
      return {
        ...state,
        audienceCount: {
          ...state.audienceCount,
          count: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
